import Item, { SHIFT_UP_DESKTOP, SHIFT_UP_MOBILE } from './Item';
import { SIZE_GROUND } from './Item';
import { TAP_LIMIT } from 'app/constants/AppConstants.js';

export default class Flashlight extends Item {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.isOn = false;

    this.ray = this.game.make.image(28, -18, 'items', 'flashlight_ray');
    this.ray.anchor.set(0, 0.5);
    this.ray.visible = false;
    this.addChild(this.ray);

    if (this.area) {
      this.area.width = 80;
    }

    // add to lights controller
    this.location.lights.addLight(this);
  }

  init(itemData) {
    if (itemData && itemData.state) {
      this.setState(itemData.state === 'on');
    }
    super.init(itemData);
  }

  get width() {
    return 350; // width with ray
  }

  canHover() {
    return !this.drag;
  }

  handleInputUp() {
    this.location.stopDragItem(this);
    this.drag = false;
    this.updateBounds();

    this.scale.set(SIZE_GROUND);

    // check if it was moved
    const dx = this.pointer.x - this.startPos.x;
    const dy = this.pointer.y - this.startPos.y;
    const dist = Math.sqrt(dx * dx + dy * dy);

    this.pointer = null;

    // switch state
    if (dist < TAP_LIMIT && this.game.deviceMetric.platform.type !== 'desktop') {
      this.handleTap();
    }

    // drop item
    this.onDrop.dispatch(this);
  }

  handleTap() {
    // fix position
    const dy =
      this.game.deviceMetric.platform.type === 'desktop' ? SHIFT_UP_DESKTOP : SHIFT_UP_MOBILE;
    this.y -= dy;

    //
    this.setState(!this.isOn);

    //
    this.game.sounds.stopAudioSprite('generic_down', { spriteID: 'sfx' });
    this.game.sounds.playSFX('item_torch', { spriteID: 'sfx' });
  }

  setState(state) {
    this.isOn = state;
    this.ray.visible = this.isOn;
  }

  putInHand(character, left) {
    super.putInHand(character, left);

    this.ray.x = (1 - this.anchor.x) * 56;
    this.ray.y = -18 + (1 - this.anchor.y) * 36;
  }

  pickupFromHand() {
    super.pickupFromHand();

    this.ray.x = (1 - this.anchor.x) * 56;
    this.ray.y = -18 + (1 - this.anchor.y) * 36;
  }

  getLight() {
    const x = this.worldPosition.x + (this.scale.x > 0 ? 170 : -170);
    const y = this.worldPosition.y - 18;
    const power = this.isOn ? 1 : 0;
    return { x, y, power, w: 120, h: 60 };
  }

  //
  serialize() {
    const data = super.serialize();
    if (data) {
      data.state = this.isOn ? 'on' : 'off';
    }
    return data;
  }
}
